import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

const API_BASE = process.env.REACT_APP_API_BASE ?? '';

export function AuthProvider({ children }) {
    const [token, setToken] = useState(() => localStorage.getItem('manage_token'));
    const [user, setUser] = useState(null);
    const [authLoading, setAuthLoading] = useState(Boolean(localStorage.getItem('manage_token')));

    const logout = useCallback(() => {
        localStorage.removeItem('manage_token');
        setToken(null);
        setUser(null);
    }, []);

    // โหลด user info เมื่อมี token
    useEffect(() => {
        if (!token) {
            setAuthLoading(false);
            return;
        }
        let cancelled = false;
        fetch(`${API_BASE}/api/auth/me`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((r) => (r.ok ? r.json() : Promise.reject()))
            .then((data) => { if (!cancelled) setUser(data); })
            .catch(() => { if (!cancelled) logout(); })
            .finally(() => { if (!cancelled) setAuthLoading(false); });

        return () => { cancelled = true; };
    }, [token, logout]);

    const login = (newToken) => {
        localStorage.setItem('manage_token', newToken);
        setToken(newToken);
    };

    const refreshUser = useCallback(() => {
        if (!token) return;
        fetch(`${API_BASE}/api/auth/me`, {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        })
            .then((r) => (r.ok ? r.json() : Promise.reject()))
            .then((data) => setUser(data))
            .catch(() => logout());
    }, [token, logout]);

    // fetch พร้อม Bearer token อัตโนมัติ
    const authFetch = useCallback(
        (url, options = {}) =>
            fetch(`${API_BASE}${url}`, {
                ...options,
                headers: {
                    'Content-Type': 'application/json',
                    ...(options.headers || {}),
                    Authorization: `Bearer ${token}`,
                },
            }),
        [token]
    );

    return (
        <AuthContext.Provider
            value={{
                token,
                user,
                role: user?.role ?? null,
                isAuthenticated: Boolean(token),
                authLoading,
                login,
                logout,
                authFetch,
                refreshUser,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
